import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class TaskReportViewModel {
    BackToSignIn: ()                 => void;
    NewLoading:   (pMessage: string) => dmLoading;
    ShowCalendar: (
         pToday:  Date
        ,pStart:  Date
        ,pEnd:    Date
        ,pTitle:  string
        ,pLangID: number
        ,pAction: (pFrom: Date, pTo: Date) => void
    ) => void;

    mlText:           MLText;
    app:              mlBroker;
    ml:               mlBroker;
    Hotel:            dmHotel;
    LangID:           number;

    Today:            Date;
    StartDate:        Date;
    EndDate:          Date;

    StartDateDisplay: string;
    EndDateDisplay:   string;

    StaffSummary:     RQService.Tasks.GetCleaningTasksStaffSummaryRow[];
    StaffData:        RQService.Tasks.GetCleaningTasksStaffDataRow[];

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                      => void
        ,pNewLoading:   (pMessage: string)      => dmLoading
        ,pShowCalendar: (
             pToday:   Date
            ,pArr:     Date
            ,pDep:     Date
            ,pTitle:   string
            ,pLangID:  number
            ,pAction:  (pFrom: Date, pTo: Date) => void
        )                                       => void
    ) {
        this.mlText       = pMLText;
        this.LangID       = this.mlText.GetLangID();
        this.app          = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml           = this.mlText.GetBroker(
            'CTMExtranetTaskReport'
        );

        this.Hotel        = pHotel;
        this.BackToSignIn = pBackToSignIn;
        this.NewLoading   = pNewLoading;
        this.ShowCalendar = pShowCalendar;

        let now           = new Date();

        this.Today        = new Date(
             now.getFullYear()
            ,now.getMonth()
            ,now.getDate()
        );
        this.StartDate    = new Date(
             this.Today.getFullYear()
            ,this.Today.getMonth()
            ,this.Today.getDate()
        );
        this.EndDate      = new Date(
             this.Today.getFullYear()
            ,this.Today.getMonth()
            ,this.Today.getDate()
        );

        this.StartDate.setDate(this.StartDate.getDate() - 7);

        this.SetStartEndDisplay();

        this.StaffSummary = [];
        this.StaffData    = [];

        this.refreshReport();
    }

    private refreshReport(): void {
        let staffSummaryParams = RQParam.TasksGetCleaningTasksStaffSummaryParams();

        staffSummaryParams.HotelID    = this.Hotel.HotelID;
        staffSummaryParams.RoomTypeID = 0;
        staffSummaryParams.StaffID    = 0;
        staffSummaryParams.StartDate  = RQApp.JSDateToRQString(this.StartDate ,false);
        staffSummaryParams.EndDate    = RQApp.JSDateToRQString(this.EndDate   ,false);
        staffSummaryParams.LangID     = this.LangID;

        let loading: dmLoading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            RQService.Tasks.GetCleaningTasksStaffSummary(staffSummaryParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) {
                    loading.Dismiss();

                    return;
                }

                let summaryList = response.RQueryResult;

                this.StaffSummary.length = 0;

                for (let i = 0; i < summaryList.length; i++) {
                    let summaryEntry = RQService.Tasks.PopulateGetCleaningTasksStaffSummaryRow(
                        summaryList[i]
                    );

                    console.log('staff summary item');

                    this.StaffSummary.push(summaryEntry);
                }
                
                let staffDataParams = RQParam.TasksGetCleaningTasksStaffDataParams();

                staffDataParams.HotelID    = this.Hotel.HotelID;
                staffDataParams.RoomTypeID = 0;
                staffDataParams.StaffID    = 0;
                staffDataParams.StartDate  = RQApp.JSDateToRQString(this.StartDate ,false);
                staffDataParams.EndDate    = RQApp.JSDateToRQString(this.EndDate   ,false);
                staffDataParams.LangID     = this.LangID;

                RQService.Tasks.GetCleaningTasksStaffData(staffDataParams).then((result) => {
                    let response = result as any;
                    
                    if (response.HasErrorOrException) {
                        loading.Dismiss();
                    
                        return;
                    }
                    
                    let dataList = response.RQueryResult;
                    
                    this.StaffData.length = 0;
                    
                    for (let i = 0; i < dataList.length; i++) {
                        let dataEntry = RQService.Tasks.PopulateGetCleaningTasksStaffDataRow(
                            dataList[i]
                        );
                    
                        console.log('staff data item');

                        this.StaffData.push(dataEntry);
                    }

                    loading.Dismiss();
                });
            });
        });
    }

    public SetStartEndDisplay(): void {
        this.StartDateDisplay = this.StartDate.toLocaleDateString(
             RQApp.LangCodesByID[this.LangID]
            ,{
                 year:  'numeric'
                ,month: '2-digit'
                ,day:   '2-digit'
            }
        );

        this.EndDateDisplay = this.EndDate.toLocaleDateString(
             RQApp.LangCodesByID[this.LangID]
            ,{
                 year:  'numeric'
                ,month: '2-digit'
                ,day:   '2-digit'
            }
        );
    }

    public ChangeDatePeriod(pFrom: Date, pTo: Date) {
        if (!(pFrom && pTo)) { return; }

        if (pTo <= pFrom) {
            pTo = new Date(
                 pFrom.getFullYear()
                ,pFrom.getMonth()
                ,pFrom.getDate()
            );

            pTo.setDate(pTo.getDate() + 1);
        }

        this.StartDate = new Date(
             pFrom.getFullYear()
            ,pFrom.getMonth()
            ,pFrom.getDate()
        );
        this.EndDate   = new Date(
             pTo.getFullYear()
            ,pTo.getMonth()
            ,pTo.getDate()
        );

        this.SetStartEndDisplay();
        this.refreshReport();
    }

    public ShowChangeDatePeriod(): void {
        this.ShowCalendar(
             this.Today
            ,this.StartDate
            ,this.EndDate
            ,this.ml.Text('StartEndDate', 'Start & End Date')
            ,this.LangID
            ,(pFrom: Date ,pTo: Date) => { this.ChangeDatePeriod(pFrom, pTo); }
        );
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/task-report/xv-task-report.ts